import { global } from "../../constants";

export const data = {
  banner: {
    base: "Services",
    background: global.banner + "maritime-law.webp",
    title: "Customs Law",
    crumb: "Customs Law",
  },
  icon: "fa-solid fa-warehouse",
  shortDescription:
    "Comprehensive advice in customs law and foreign trade to optimize regimes, compliance, and logistics operations.",

  title: "Customs Law",
  features: {
    title: "Customs Law",
    deliverables: "Deliverables",
    reqDocuments: "Required Documents",
    subtitle:
      "Customs planning, regulatory compliance, and design of operational strategies for import, export, and transit operations.",
    description: `Customs diagnosis and planning services: we identify the applicable regulatory framework, classify goods, propose regimes, and design operational processes that minimize customs risks and costs, ensuring compliance with the competent authorities.`,
    viewDetail: "View Details",
    feats: [
      {
        key: "diagnosis",
        title: "Diagnosis and analysis of the customs environment",
        summary:
          "Comprehensive evaluation of the operational context: logistics routes, entry/exit points, and involved actors (freight agents, port operators).",
        details:
          "We map the logistics chain and perform a current compliance diagnosis that identifies bottlenecks, non-compliance risks, and optimization opportunities in import/export and customs transit processes.",
        deliverables: [
          "Customs diagnosis report",
          "Map of logistics processes and risk points",
          "Prioritized improvement recommendations",
        ],
        requiredDocs: [
          "Current import/export flow",
          "Contracts with agents/logistics",
          "Recent customs documentation (pedimentos, manifests)",
        ],
        icon: "fa-solid fa-search",
        image: global.services + "customs_law/1.webp",
      },
      {
        key: "regulation",
        title:
          "Identification of applicable regulations and tariff classification",
        summary:
          "We determine the legal framework, applicable tariffs, and correct tariff classification (HS) of goods.",
        details:
          "We analyze current laws, decrees, resolutions, and tariff schedules; we perform tariff classification (HS/SA) and customs valuation according to international and local rules, reducing the risk of adjustments and sanctions.",
        deliverables: [
          "Tariff classification sheet by product",
          "Report of applicable regulatory obligations",
          "Estimated calculation of duties and associated costs",
        ],
        requiredDocs: [
          "Technical/commercial sheet of goods",
          "Proforma/final invoices",
          "Origin documentation (certificates if applicable)",
        ],
        icon: "fa-solid fa-file-lines",
        image: global.services + "customs_law/2.webp",
      },
      {
        key: "regimes",
        title: "Planning of customs regimes and use of benefits",
        summary:
          "Design and evaluation of customs regimes (bonded warehouse, free zone, transit, temporary admission, improvement regime).",
        details:
          "We evaluate the convenience of customs regimes according to operations (temporary import, re-export, transformation, storage in bonded warehouse or free zone), optimizing tariff and storage costs, and managing requirements to access benefits such as draw-back or exemptions.",
        deliverables: [
          "Evaluation of recommended regimes",
          "Customs regime implementation plan",
          "Estimated savings model and operational flow",
        ],
        requiredDocs: [
          "Import/export history",
          "Storage/transport contracts",
          "Previous permits or certifications",
        ],
        icon: "fa-solid fa-box-open",
        image: global.services + "customs_law/3.webp",
      },
      {
        key: "optimization",
        title:
          "Optimization of regulatory compliance and operational processes",
        summary:
          "Improvements in internal procedures, documentation, and dispatch flows to reduce times and contingencies.",
        details:
          "We design standardized procedures for customs dispatch, prior document validation, accounting-customs reconciliations, inventory controls, and preparation of documentation for audits, incorporating automation and checklists to reduce errors.",
        deliverables: [
          "Customs process manual",
          "Checklists for dispatch and reception",
          "Documentation and control templates",
        ],
        requiredDocs: [
          "Current procedures",
          "Management/ERP systems (if applicable)",
          "Previous discrepancy reports",
        ],
        icon: "fa-solid fa-cogs",
        image: global.services + "customs_law/4.webp",
      },
      {
        key: "operations",
        title: "Design of operational strategies and customs supply chain",
        summary:
          "Redesign of the logistics chain to improve times, costs, and integration with customs and port operators.",
        details:
          "We propose alternative routes, agreements with operators, optimization of consolidation/deconsolidation, and synchronization of documentation to anticipate dispatch. Includes recommendations for selection of appropriate Incoterms and contractual management with customs agents and shipping companies.",
        deliverables: [
          "Operational plan for customs supply chain",
          "Model of agreements with operators and SLA",
          "Recommendation of Incoterms and contractual clauses",
        ],
        requiredDocs: [
          "Contracts with agents and carriers",
          "Records of times and delays",
          "Inventory and consolidation policies",
        ],
        icon: "fa-solid fa-route",
        image: global.services + "customs_law/5.webp",
      },
      {
        key: "risks",
        title: "Risk management, customs audits, and training",
        summary:
          "Control programs, internal audit, and training to mitigate sanctions and improve continuous compliance.",
        details:
          "We implement customs risk management plans, prepare the organization for inspections and audits, and offer specific training for operational and administrative teams on classification, valuation, documentation, and preventive controls.",
        deliverables: [
          "Customs risk management program",
          "Internal audit report and action plan",
          "Tailored training plan (workshops and materials)",
        ],
        requiredDocs: [
          "Previous audit reports",
          "Records of non-compliance and fines",
          "List of key personnel and operational roles",
        ],
        icon: "fa-solid fa-shield-halved",
        image: global.services + "customs_law/6.webp",
      },
    ],
  },
  ctaText: "Request customs advice",
  ctaLink: "/contact?service=customs-law",
};
